import React from 'react';

interface NotepadFrameProps {
  children: React.ReactNode;
  className?: string;
  borderRadius?: number;
}

export const NotepadFrame: React.FC<NotepadFrameProps> = ({
  children,
  className = '',
  borderRadius = 8
}) => {
  return (
    <div
      className={`notepad-frame bg-[#FFE895] overflow-hidden h-full flex flex-col ${className}`}
      style={{
        borderRadius: `${borderRadius}px`,
        isolation: 'isolate'
      }}
    >
      <div
        className="notepad-header bg-[#FEE27C] px-4 py-3 flex-shrink-0 border-b border-[#E8D89A]"
        style={{
          borderTopLeftRadius: `${borderRadius}px`,
          borderTopRightRadius: `${borderRadius}px`
        }}
      >
        <div className="w-full h-1"></div>
      </div>
      <div className="notepad-content flex-1 overflow-hidden">
        {children}
      </div>
    </div>
  );
};
